import {
  ModalSectionButton,
  ModalText,
  ModalTitle,
} from "../modules/modal/modalComponents";
import React from "react";
import styled from "styled-components";

function SelectionCard({item, onClick, ...props}) {
  const Icon = item.icon;
  return (
    <SelectionCardContainer onClick={onClick} data-testid={props["data-testid"]}>
      {Icon ? <Icon /> : null}
      <ModalTitle>{item.label}</ModalTitle>
      <Description>{item.description}</Description>
    </SelectionCardContainer>
  );
}

const Description = styled(ModalText)`
  text-align: center;
`;
const SelectionCardContainer = styled(ModalSectionButton)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: auto;
  align-items: center;
  align-content: center;
  border: 1px solid ${({theme}) => theme.v2.color.base.grey["400"]};
  border-radius: ${({theme}) => theme.v2.decoration.border.radius.default};
  padding: ${({theme}) => theme.v2.spacing(2)};
  margin: ${({theme}) => theme.v2.spacing(2)};
  background-color: ${({theme}) => theme.v2.color.base.grey["50"]};
  cursor: pointer;
  padding: ${({theme}) => theme.v2.spacing(2)};
  &:hover {
    opacity: 100%;
    border: 1px solid ${({theme}) => theme.v2.color.primary};
  }
  > * {
    margin: ${({theme}) => theme.v2.spacing(1)};
  }
`;

export default SelectionCard;
